export default __webpack_public_path__ + "static/Contractors execute the highest risks activities for employing companies-a0996e9a2abd0651de888931e6202ec3.jpg";